<template>
  <div
    :class="{
      [$style.dark]: settings.menuColor === 'dark',
    }"
  >
    <div :class="$style.logoContainer">
      <a-button
        title="Collapse menu"
        :icon="settings.isShowLeftCol ? 'menu-fold' : 'menu-unfold'"
        type="link"
        style="margin-right: 10px; border: 0;"
        @click="onCollapseMenu"
      >
      </a-button>
      <a-tooltip title="List App">
        <a-icon
          type="appstore"
          @click="visible = !visible"
          :class="[$style.appIcon, 'mr-3']"
          style="font-size: 2rem;"
        />
      </a-tooltip>

      <div :class="$style.logo">
        <img
          v-if="!loadingList"
          :src="logoUrl"
          class="mr-3"
          :alt="appConfigOrganization.name"
          style="height: 45px;"
        />
        <a-icon v-if="loadingList" type="loading" spin />
        <div :class="$style.name">
          <router-link to="/">{{ settings.logo }}</router-link>
        </div>
      </div>
      <a-drawer
        placement="left"
        @close="onCloseDrawer"
        :closable="false"
        :visible="visible"
        width="350"
      >
        <div style="margin-top: -18px;">
          <div :class="$style.logoContainer" style="float: right;">
            <a-button
              @click="visible = !visible"
              style="font-size: 1rem; float: right;"
              type="link"
            >
              <a-icon type="close" :class="[$style.appIcon]" />
            </a-button>

            <div :class="$style.logo" @click="visible = !visible">
              <div :class="$style.name">{{ settings.logo }}</div>
              <div v-if="settings.logo === 'ICT24H'" :class="$style.descr">
                Vue
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <ListApp
            :close="onCloseDrawer"
            :appConfigOrganization="appConfigOrganization"
          />
        </div>
      </a-drawer>
    </div>
  </div>
</template>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<script>
import { mapState } from "vuex";
import ListApp from "./ListApp/index.vue";
import query from "./constants/query";

export default {
  components: { ListApp },
  data() {
    return {
      logoUrl: "resources/images/logo-phucatthai-2.png",
      visible: false,
      appConfigOrganization: {},
      loadingList: false,
    };
  },
  computed: {
    ...mapState(["settings"]),
  },
  methods: {
    onCloseDrawer() {
      this.visible = false;
    },
    onGetAppConfigOrganization() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAppConfigOrganization,
        })
        .then(({ data }) => {
          if (data?.getAppConfigOrganization) {
            this.appConfigOrganization = { ...data.getAppConfigOrganization };
            this.logoUrl = data.getAppConfigOrganization.logoUrl;
            this.$store.commit("SET_LOGO_URL", { logoUrl: this.logoUrl });
          }
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
          console.error("Error get list", error);
        });
    },
    onCollapseMenu() {
      if (this.settings.isDrawerMenu) {
        this.$store.commit("SET_OPEN_DRAWER_MENU");
      } else {
        this.$store.commit("SET_LEFT_COL");
      }
    },
  },
  created() {
    this.onGetAppConfigOrganization();
  },
};
</script>
